import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPhone(value: string): string {
  const digits = (value || "").replace(/\D/g, "").slice(0, 11)
  if (!digits) return ""
  if (digits.length <= 2) return `(${digits}`
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`
}

/**
 * Verifica se a aplicação está rodando em ambiente de Alpha ou Beta
 * a partir das variáveis de ambiente (APP_ENV, NEXT_PUBLIC_APP_ENV, APP_URL, NEXT_PUBLIC_APP_URL, PORT, etc.)
 * ou da URL do navegador.
 */
export function isAlphaOrBetaEnvironment(): boolean {
  // 1. Variáveis de ambiente diretas de tipo de ambiente
  const envName = (
    process.env.NEXT_PUBLIC_APP_ENV ||
    process.env.NEXT_PUBLIC_ENVIRONMENT ||
    process.env.APP_ENV ||
    process.env.ENVIRONMENT ||
    ""
  ).toLowerCase().trim()

  if (envName === "alpha" || envName === "beta" || envName.includes("alpha") || envName.includes("beta")) {
    return true
  }

  // 2. URLs de aplicação configuradas nas variáveis de ambiente
  const appUrl = (
    process.env.NEXT_PUBLIC_APP_URL ||
    process.env.APP_URL ||
    ""
  ).toLowerCase().trim()

  if (appUrl.includes("alpha") || appUrl.includes("beta")) {
    return true
  }

  // 3. Portas padrão de ambiente (1000 para Alpha, 2000 para Beta conforme documentado)
  const port = (
    process.env.NEXT_PUBLIC_PORT ||
    process.env.PORT ||
    ""
  ).trim()

  if (port === "1000" || port === "2000") {
    return true
  }

  // 4. Verificação no banco de dados (search_path de Alpha/Beta na DATABASE_URL)
  const dbUrl = (process.env.DATABASE_URL || "").toLowerCase()
  if (dbUrl.includes("search_path=alpha") || dbUrl.includes("search_path=beta")) {
    return true
  }

  // 5. Verificação em tempo de execução no navegador (hostname e porta da janela)
  if (typeof window !== "undefined") {
    const hostname = (window.location.hostname || "").toLowerCase()
    if (hostname.includes("alpha") || hostname.includes("beta")) {
      return true
    }
    const currentPort = window.location.port
    if (currentPort === "1000" || currentPort === "2000") {
      return true
    }
  }

  return false
}
